/** The business time zone of dates and periods. The API echoes it in every response's meta. */
export const BUSINESS_TIMEZONE: string =
  (import.meta.env.VITE_BUSINESS_TIMEZONE as string | undefined) ?? 'Asia/Tashkent';

/** Where the API lives. Same origin: Vite proxies it in development, Nginx in production. */
export const API_BASE = '/api/v1';

/**
 * Static demo build (ADR-027): the dashboard reads exported demo responses from files instead of
 * the API, so it can be hosted without a server for feedback. Never used with real data.
 */
export const STATIC_DEMO: boolean = import.meta.env.MODE === 'static-demo';
